import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=32987b54"
import script from "./Materials.vue?vue&type=script&lang=ts"
export * from "./Materials.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports